export default __webpack_public_path__ + "static/media/idx1.5bf255a5.png";